import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { CustomerModel } from '../models/customer.model';

@Injectable({
    providedIn: 'root'
})
export class BolagsverketService {
    private apiUrl = `${environment.apiUrl}`;

    constructor(private http: HttpClient) { }

    searchCompany(query: string): Observable<{ data: CustomerModel[] }> {
        return this.http.get<{ data: CustomerModel[] }>(
            `${this.apiUrl}/bolagsverket/search`,
            { params: { q: query } }
        );
    }
}